import { Button, Link } from 'components'
import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

type BootcampCardTypes = {
  topic: string
  description: string
  badges: string[]
  prices: string
  to: string
}

const BootcampCard = (props: BootcampCardTypes) => {
  const { to, badges, prices, topic, description } = props
  return (
    <div className="bg-zinc-900/20 w-full sm:w-[370px] border border-[#8080FF] rounded-lg">
      <div className="p-7 flex flex-col items-center gap-4">
        <div>
          <h3 className="text-4xl font-bold text-primary-very-light">
            {topic}
          </h3>
        </div>
        <p className="text-center text-gray-50">{description}</p>
        <div className="flex flex-wrap gap-2 justify-center">
          {badges.map((badge) => (
            <Badge key={badge} content={badge} />
          ))}
        </div>
      </div>
      <div className="py-7 px-9 bg-white/10">
        <div className="flex flex-row items-center justify-between">
          <p className="text-white font-medium">{prices}</p>
          <Link href={to}>
            <Button
              variant="transparent"
              className="gap-1 items-center justify-center text-primary hover:text-primary hover:bg-white/10">
              Explore <ArrowRightIcon className="w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default BootcampCard

const Badge = ({ content }: { content: string }) => {
  return (
    <div className="rounded-full bg-white/80 px-6 py-1.5">
      <p className="text-primary-dark text-center">{content}</p>
    </div>
  )
}
